export default __webpack_public_path__ + "static/media/firstDance2.5ca0e244.jpg";